import { api } from "@/lib/api";

// Curated Phase-1 Channel Descriptor fonts. Fetched once from the backend (single source of truth
// shared with GRS) and cached for the session. The Branding editor uses this for the picker and to
// load the same Google Fonts family that GRS burns in — so preview and rendered output match.
let _cache = null;
let _inflight = null;

export async function getDescriptorFonts() {
  if (_cache) return _cache;
  if (!_inflight) {
    _inflight = api.get("/branding/descriptor-fonts")
      .then((r) => { _cache = r.data.fonts || []; return _cache; })
      .catch(() => { _cache = [{ key: "system", label: "System Default", css: "", stack: "system-ui, sans-serif", category: "sans" }]; return _cache; });
  }
  return _inflight;
}

// Inject the Google Fonts stylesheet for a family (once). "system"/empty families are a no-op.
const _loaded = new Set();
export function loadDescriptorFont(cssFamily) {
  if (!cssFamily || _loaded.has(cssFamily) || typeof document === "undefined") return;
  _loaded.add(cssFamily);
  const id = "gf-" + cssFamily.replace(/\s+/g, "-").toLowerCase();
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=" +
    encodeURIComponent(cssFamily).replace(/%20/g, "+") + ":wght@400;600;700&display=swap";
  document.head.appendChild(link);
}

// Preview base font size (px) per operator-friendly bucket. Matches GRS scale (0.8 / 1.0 / 1.4).
export const DESCRIPTOR_BASE_PX = { small: 12, medium: 15, large: 21 };

// Resolve a channel `branding.descriptor` object into inline styles for the preview overlay.
export function descriptorStyles(descriptor) {
  const d = descriptor || {};
  const base = DESCRIPTOR_BASE_PX[d.font_size] || DESCRIPTOR_BASE_PX.medium;
  const bg = Math.max(0, Math.min(100, d.bg_opacity ?? 50)) / 100;
  return {
    box: { backgroundColor: `rgba(0,0,0,${bg})` },
    text: { fontFamily: d.css_stack || undefined },
    labelPx: Math.round(base * 0.74),
    titlePx: Math.round(base * 1.05),
    descPx: Math.round(base * 0.82),
  };
}
